var map = {
	"./cut-wave.svg": "./svg/cut-wave.svg",
	"./icon-all.svg": "./svg/icon-all.svg",
	"./icon-arrow-right-bold.svg": "./svg/icon-arrow-right-bold.svg",
	"./icon-arrow-right.svg": "./svg/icon-arrow-right.svg",
	"./icon-checkmark-bold.svg": "./svg/icon-checkmark-bold.svg",
	"./icon-checkmark.svg": "./svg/icon-checkmark.svg",
	"./icon-chevron-down-bold.svg": "./svg/icon-chevron-down-bold.svg",
	"./icon-chevron-down-medium.svg": "./svg/icon-chevron-down-medium.svg",
	"./icon-chevron-down.svg": "./svg/icon-chevron-down.svg",
	"./icon-chevron-right.svg": "./svg/icon-chevron-right.svg",
	"./icon-cross-thin.svg": "./svg/icon-cross-thin.svg",
	"./icon-cross.svg": "./svg/icon-cross.svg",
	"./icon-filters.svg": "./svg/icon-filters.svg",
	"./icon-info.svg": "./svg/icon-info.svg",
	"./icon-logo-wiggleline.svg": "./svg/icon-logo-wiggleline.svg",
	"./icon-marker.svg": "./svg/icon-marker.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./svg sync recursive \\.svg$";